<template>
  <div>
    <el-card shadow="always">
      <el-button size="small" type="primary" @click="addData">添加</el-button>
      <el-button size="small" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
    </el-card>
    <el-table height="600" size="small" :data="tableData" border :default-expand-all="false" row-key="id" class="box-card mt10">
      <el-table-column prop="name" label="权限名称" width="220" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="path" label="路径" width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="editData(scope.row)">编辑</el-button>
          <el-button size="mini" type="warning" @click="delData(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="450px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <perm-save ref="permSaveRef" @callMethod="refresh"></perm-save>
    </el-dialog>
  </div>
</template>

<script>
import PermSave from '@/components/auth/permSave.vue'
export default {
  name: 'authPermissions',
  components: {
    PermSave
  },
  inject: ['reload'],
  created() {
    this.getData()
  },
  data() {
    return {
      dialogTitle: '',
      dialogShow: false,
      tableData: []
    }
  },
  methods: {
    async getData() {
      await this.$api.auth.permList().then(res => {
        if (res.code == 200) {
          this.tableData = res.data ? res.data : []
        }
      })
    },
    addData() {
      this.dialogTitle = '添加权限'
      this.dialogShow = true
      this.$nextTick(() => {
        this.$refs.permSaveRef.setData(this.tableData)
      })
    },
    editData(data) {
      this.dialogTitle = '编辑权限'
      this.dialogShow = true
      this.$nextTick(() => {
        this.$refs.permSaveRef.setData(this.tableData, data)
        this.reload()
      })
    },
    async delData(id) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await this.$api.auth.menuDel({ id: id }).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.getData()
              this.reload()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    refresh() {
      this.dialogShow = false
      this.getData()
    }
  }
}
</script>
